var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as CheckoutEvent from "./CheckoutEvent";
import * as ShoppingCart from "./ShoppingCart";
const CHECKOUT_CONFIG_FIELDS = gql `
  fragment CheckoutConfigFields on CheckoutConfig {
    eventId
    enableCaptcha
    paymentProcessor
    processorPublicKey
    processorAccountId
    recaptchaInvisibleSiteKey
    recaptchaCheckboxSiteKey
    recaptchaUpdateCartAction
    recaptchaCompleteOrderAction
    donation
    accessCode
    discount
    published
    includeConvenienceFee
    includeTaxFee
    includeCcFee
    requirePhoneNumber
    hiveBrandId
    layloKey
    checkboxes {
      key
      label
      required
      description
      descriptionTitle
    }
    quickCheckoutTos {
      key
      label
      required
      description
      descriptionTitle
    }
    alerts {
      title
      messages
    }
    tracking {
      provider
      trackingId
    }
    features {
      feature
      enabled
    }
  }
`;
// Temp export
export const EVENT_FIELDS = gql `
  fragment EventFields on CheckoutEvent {
    doorTime
    endTime
    id
    slug
    minimumAge
    name
    promoter
    support
    startTime
    endTime
    footerContent
    description
    usesSeatingChart
    images {
      name
      highlighted
      variants {
        src
        variant
      }
    }
    seatingChartConfig {
      workspaceKey
      eventKey
      region
      objectWithoutPricingSelectable
    }
    venue {
      city
      country
      currency
      lat
      locale
      long
      name
      postal
      state
      street1
      street2
      timeZone
      logoUrl
    }
    artists {
      name
      links {
        url
      }
    }
  }
`;
export const ORDER_SUMMARY_FIELDS = gql `
  fragment OrderSummaryFields on OrderSummary {
    fingerprint
    state
    customer {
      email
      firstName
      lastName
      phoneNumber
    }
    address {
      street1
      street2
      city
      state
      postalCode
      country
    }
    event {
      ...EventFields
    }
    breakdown {
      itemsBreakdown {
        amount
        key
        label
      }
      itemsTotal
      orderTotal
      totalBreakdown {
        amount
        key
        label
      }
    }
    items {
      name
      seat
      table
      discountCode
      breakdown {
        basePrice
        convenienceFee
        discountAmount
        price
        total
      }
    }
  }
  ${EVENT_FIELDS}
`;
const GET_EVENT_QUERY = gql `
  query GetEvent($eventId: Int, $slug: String) {
    checkout {
      event(id: $eventId, slug: $slug) {
        ...EventFields
        config {
          ...CheckoutConfigFields
        }
      }
    }
  }
  ${EVENT_FIELDS}
  ${CHECKOUT_CONFIG_FIELDS}
`;
export const getEvent = (client, eventIdOrSlug) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    let eventId = null;
    let slug = null;
    if (typeof eventIdOrSlug === 'number') {
        eventId = eventIdOrSlug;
    }
    else if (eventIdOrSlug.includes('-')) {
        slug = eventIdOrSlug;
    }
    else {
        eventId = Number(eventIdOrSlug);
        if (isNaN(eventId)) {
            throw new Error('Invalid value provided for `eventIdOrSlug`');
        }
    }
    const { data } = yield client.query({
        query: GET_EVENT_QUERY,
        variables: {
            eventId,
            slug,
        },
        fetchPolicy: 'network-only',
    });
    if (!((_a = data.checkout) === null || _a === void 0 ? void 0 : _a.event)) {
        throw new Error('Event not found placeholder');
    }
    return CheckoutEvent.fromGql((_b = data.checkout) === null || _b === void 0 ? void 0 : _b.event);
});
export const SHOPPING_CART_FRAGMENT = gql `
  fragment ShoppingCartFields on ShoppingCart {
    token
    notABotUntil
    priceBreakdown {
      itemsBreakdown {
        amount
        key
        label
      }
      itemsTotal
      orderTotal
      totalBreakdown {
        amount
        key
        label
      }
    }
    controlQuantity
    items {
      typeHash
      name
      itemId
      itemType
      count
      amount
      details
      breakdown {
        basePrice
        price
        total
      }
    }
    lockExpiresAt
  }
`;
const GET_SHOPPING_CART_QUERY = gql `
  query GetShoppingCart($eventId: Int!, $token: String) {
    checkout {
      shoppingCart(eventId: $eventId, token: $token) {
        ...ShoppingCartFields
      }
    }
  }
  ${SHOPPING_CART_FRAGMENT}
`;
export const getShoppingCart = (client, token, eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: GET_SHOPPING_CART_QUERY,
        fetchPolicy: 'network-only',
        variables: {
            token,
            eventId,
        },
    });
    return ShoppingCart.fromGql(data.checkout.shoppingCart);
});
//# sourceMappingURL=Api.js.map